import { Box, VStack } from "@chakra-ui/react";
import { useCallback, useEffect, useState } from "react";
import {
  KYDInternalCampaign,
  KYDCampaignMetricsSummary,
} from "@common/interfaces/KYDCampaign";
import actions from "src/actions";
import { KYDScope } from "@common/interfaces/ICognito";
import { KYDOrganizationFull } from "@common/interfaces/KYDOrganization";
import EmailCampaignsTab from "./EmailCampaignsTab";

const CampaignsOverview = ({
  permissions = [],
  organization,
}: {
  permissions?: KYDScope[];
  organization?: KYDOrganizationFull;
}) => {
  const [campaigns, setCampaigns] = useState<KYDInternalCampaign[]>([]);
  const [summary, setSummary] = useState<KYDCampaignMetricsSummary>();
  const [loading, setLoading] = useState({
    dashboard: true,
  });

  const fetchCampaigns = useCallback(async () => {
    try {
      setLoading((prev) => ({
        ...prev,
        dashboard: true,
      }));
      const response = await actions.ADMIN.fetchCampaignsDashboard();
      setCampaigns(response.campaigns);
      setSummary(response.metrics);
    } catch (error) {
      console.error("Error fetching campaigns:", error);
    } finally {
      setLoading((prev) => ({
        ...prev,
        dashboard: false,
      }));
    }
  }, []);

  useEffect(() => {
    fetchCampaigns();
  }, [fetchCampaigns]);

  return (
    <VStack w={"100%"} alignItems={"flex-start"} py={4}>
      <Box w="100%">
        <EmailCampaignsTab
          permissions={permissions}
          organization={organization}
          campaigns={campaigns}
          summary={summary}
          loadingDashboard={loading.dashboard}
          onRefresh={fetchCampaigns}
        />
      </Box>
    </VStack>
  );
};

export default CampaignsOverview;
